import { getSnapshotOptionTitle } from 'components/SelectSnapshot/getSnapshotOptionTitle';
import type { Snapshot } from 'pages/SnapshotManagement/snapshotManagementTypes';
import { memo } from 'react';
import type { FC } from 'react';

import { SnapshotLabel } from 'components/SnapshotLabel/SnapshotLabel';
import { type SingleValueProps, components } from 'react-select';

type Props = SingleValueProps<Snapshot>;

const BareSelectSnapshotValue: FC<Props> = (props) => {
  const hasError = props.data.status === 'error';

  return (
    <components.SingleValue {...props}>
      <div className='select-snapshot__value-wrapper flex flex-row'>
        <div>
          <SnapshotLabel
            name={getSnapshotOptionTitle(
              props.data.name,
              props.data.status === 'canceled',
            )}
            date={props.data.tsStart}
            disabled={props.isDisabled}
            error={hasError}
            compact
            ellipsis={props.data.running}
          />
        </div>
        <span className='select-snapshot__spinner-wrapper'>
          {props.data.running && (
            <i className='fa-regular fa-spinner fa-spin select-snapshot__spinner' />
          )}
        </span>
      </div>
    </components.SingleValue>
  );
};

export const SelectSnapshotValue = memo(BareSelectSnapshotValue);
